export default {
  AUTHENTICATED: 'Authenticated',
  PUBLIC: 'Public',
  SEGRETERIA_NAZIONALE: 'Segreteria nazionale',
  DELEGATO_SEZIONE: 'Delegato di sezione',
  DELEGATO_REGIONE: 'Delegato di regione',
};
